var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { service } from './app.service';
import DiscountModel from '@/models/DiscountModel';
import localStorageAdapter from '@/utils/LocalStorageAdapter';
var pathGetCoupon = 'squib_get_coupon';
var endpointGetCoupon = function (base, code, menuId, serviceType) { return "/admin/" + pathGetCoupon + "?b=" + base + "&c=" + code + "&m=" + menuId + "&s=" + serviceType; };
// TODO use when we start integrating server calls into discounts
var couponService = {
    fetchCoupon: function (locationBase, coupon, menuId, serviceType, callback) {
        var url = endpointGetCoupon(locationBase, coupon, menuId, serviceType);
        service.get(url).then(function (response) {
            var responseData = response.data;
            var discount = responseData.body;
            var couponDiscount = null;
            var message = responseData.message;
            if (discount && discount.discount_id) {
                couponDiscount = new DiscountModel(__assign({}, discount, { menu_id: menuId }));
            }
            callback({
                coupon: couponDiscount,
                message: message,
            });
        }).catch(function (error) {
            console.error("Error in fetching coupon: " + error);
        });
    },
    getItemsFromDiscount: function (discount) {
        if (!discount) {
            return [];
        }
        return discount.getOptionsInDiscount();
    },
    getCouponFromStorage: function () {
        return localStorageAdapter.getCoupon();
    }
};
export { couponService };



//////////////////
// WEBPACK FOOTER
// ./src/services/coupon.service.ts
// module id = 5N7Z
// module chunks = 18